var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDynamics365 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 30,
    height: 30,
    x: 5,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 5H5v30h30z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 23,
    height: 30,
    x: 8,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.625 14.702c0-1.32-.83-2.499-2.074-2.943l-18.13-6.475A1.25 1.25 0 0 0 8.75 6.461v9.846c0 .528.332 1 .83 1.177l8.125 2.902a1.25 1.25 0 0 0 1.67-1.178v-5.653c0-.436.436-.739.845-.585l2.13.802a3.125 3.125 0 0 1 2.025 2.925v2.462l-9.179 3.354a1.25 1.25 0 0 0-.821 1.174v9.838a1.25 1.25 0 0 0 1.679 1.174l12.519-4.574a3.125 3.125 0 0 0 2.052-2.935z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M8.75 4.688 30.625 12.5v10.726a1.25 1.25 0 0 1-1.67 1.178l-4.58-1.636v-6.073a3.125 3.125 0 0 0-2.026-2.925l-2.13-.8a.625.625 0 0 0-.844.585v7.427L8.75 17.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.24,
    d: "M30.625 14.812c0 1.313-.82 2.488-2.052 2.938l-14.198 5.188v12.5l16.25-5.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.32,
    d: "M30.625 15.312c0 1.313-.82 2.487-2.052 2.938l-14.198 5.188v12.5L30.625 30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M30.625 14.687c0 1.313-.82 2.487-2.052 2.938l-14.198 5.188v12.5l16.25-5.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M30.625 14.687c0 1.313-.82 2.487-2.052 2.938l-14.198 5.188v12.5l16.25-5.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0ADFF",
    d: "m24.375 19.163-5.002 1.83v7.33c0 .437.436.74.845.585l2.133-.803a3.125 3.125 0 0 0 2.024-2.924z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 16.889,
    x2: 29.075,
    y1: 4.688,
    y2: 24.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B53CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7252AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 23.111,
    x2: 23.111,
    y1: 34.277,
    y2: 6.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2266E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE7FE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 30.625,
    x2: 22.244,
    y1: 16.897,
    y2: 16.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#94B9FF",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#538FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h30v30H5z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDynamics365);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dynamics365.9d9ac977.svg";